package example.shadcn_kotlin.ui.pages.docs.components

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.*
import com.varabyte.kobwebx.markdown.*
import example.shadcn_kotlin.ui.components.*

@Page
@Composable
fun ToastPage() {
    CompositionLocalProvider(LocalMarkdownContext provides MarkdownContext("docs/components/toast.md", mapOf("title" to listOf("Toast"), "description" to listOf("A succinct message that is displayed temporarily."), "radix" to listOf(), "link" to listOf("https://www.radix-ui.com/docs/primitives/components/toast"), "api" to listOf("https://www.radix-ui.com/docs/primitives/components/toast#api-reference")))) {
        example.shadcn_kotlin.ui.components.layouts.MDLayout {
            org.jetbrains.compose.web.dom.P({ classes("leading-7","[&:not(:first-child)]:mt-6") }) {
                org.jetbrains.compose.web.dom.Text("Currently, Toast component doesn't work. Maybe if you can figure it out raise a Pull Request.")
            }
        }
    }
}
